import { gql } from '@apollo/client';

export const DELETE_MONITORINGFORM = gql`
  mutation deleteMonitoringForm($id: ID!) {
    monitoringForm: deleteMonitoringForm(id: $id) {
      id
    }
  }
`;
